/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.success\":[\"Circle with checkmark\"]}");